import { createQueryKeys } from '@lukemorales/query-key-factory';

import type { FetchDailyArgs } from '../api/types/stats.types';

import { fetchDaily } from '../api/measurementsStats.api';

export const statsMeasurementsQueryKeys = createQueryKeys('statsMeasurements', {
  fetchDaily: (args: FetchDailyArgs = {}) => ({
    queryFn: () => fetchDaily(args),
    queryKey: [args],
  }),
});
